import { Injectable } from '@angular/core';

import { ApiService } from '../../../../../common/services/api.service';
import { environment } from 'src/environments/environment';
import { apiEndPoints } from '../../../../../common/constants/api-endpointsconstant';
import { ReportService } from 'src/app/reports/services/report.service';
import { LoaderType } from 'src/app/common/models/enums/common.enum';

@Injectable({
  providedIn: 'root'
})
export class ReportFbService {

  constructor(
    private apiServive: ApiService,
    private reportService: ReportService
  ) { }

  getTotalfbReport(year = null){
    
    const url: string = `${environment.miUrl}${apiEndPoints.retailfnbTotalReport}${this.reportService.filterQueryParams}`;
    return this.apiServive.get(url);
  }

  getRetailFnbCuisineWiseSplitAreaReport(year = null){
    let queryParams = {...this.reportService.queryParams};
    if(queryParams?.year){
      queryParams.year = year ? year : this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.retailFnbCuisineWiseSplitAreaReport}${changeParams}`;
    return this.apiServive.get(url);
  }

  getRetailFnbCategoryWiseReport(year = null){
    let queryParams = {...this.reportService.queryParams};
    if(queryParams?.year){
      queryParams.year = year ? year : this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.retailFnbCategoryWiseReport}${changeParams}`;
    return this.apiServive.get(url);
  }

  getRetailfnbTrendAreaTentantReport(year = null){
    let queryParams = {...this.reportService.queryParams};
    if(queryParams?.year){
      queryParams.year = year ? year : this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let url: string = `${environment.miUrl}${apiEndPoints.retailfnbTrendAreaTentantReport}${changeParams}`;
    return this.apiServive.get(url);
  }

  getRetailfnbAverageLeaseCategoryReport(year = null){
    let queryParams = {...this.reportService.queryParams};
    if(queryParams?.year){
      queryParams.year = year ? year : this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let url: string = `${environment.miUrl}${apiEndPoints.retailfnbAverageLeaseCategoryReport}${changeParams}`;
    return this.apiServive.get(url);
  }
}
